// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetailsPreview-module__main--hsfIx {
    padding: 12px 20px;
    overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/OrderDetails/OrderDetailsPreview.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".main {\n    padding: 12px 20px;\n    overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `OrderDetailsPreview-module__main--hsfIx`
};
export default ___CSS_LOADER_EXPORT___;
